export const CHECKBOX_ID = 'cacheQuery';

export const REFRESH_MINIMUM = 4;
export const REFRESH_MAXIMUM = 48;
